<template>
    <div class="card card-basic card--blue">
        <div class="card__text">
            <div class="card__text__top">
                <span class="card__subject">
                    <a href="#" @click.prevent="emitUpdateEvent(cardData.id)">
                        {{ cardData.name }}
                    </a>
                </span>
                <h2>
                    {{ cardData.info }}
                    {{ cardData.shoptName }}
                </h2>
                <ul class="mb-2 list-unstyled card__list font-italic">
                    <li v-for="theme in cardData.themes" :key="theme.id">
                        {{ theme.name }}
                    </li>
                </ul>
                <ul class="mb-2 list-unstyled card__list font-italic">
                    <li>
                        {{ cardData.address }}
                    </li>
                    <li>{{ cardData.postalcode }} {{ cardData.city }}</li>
                    <li>
                        {{ cardData.country }}
                    </li>
                    <li>
                        {{ cardData.phone }}
                    </li>
                </ul>
            </div>
        </div>
        <div
            v-if="cardData.children !== null && cardData.children.length"
            class="card__bottom bg--blue align-self-end"
        >
            <div v-collapse-content>
                <ul
                    v-if="cardData.children"
                    class="color--white list-unstyled p-0"
                >
                    <li v-for="child in cardData.children" :key="child.id">
                        <a
                            class="color--white"
                            href="#"
                            @click.prevent="emitUpdateEvent(child.id)"
                        >
                            {{ child.name }}
                        </a>
                    </li>
                </ul>
            </div>
            <div v-collapse-toggle class="card__bottom__button">
                <div
                    class="card__bottom__button__content d-block w-100 position-relative"
                >
                    <span class="card__bottom__read-more">Meer</span
                    ><span
                        class="icon-angle-down card__bottom__button__content__icon"
                    ></span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        cardData: {
            type: Object,
            default() {
                return {};
            }
        },
        readMore: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    methods: {
        emitUpdateEvent(id) {
            this.$emit('update', id);
        }
    }
};
</script>

<style lang="scss" scoped>
.card {
    height: auto;
    display: flex;
    flex-direction: column;
}

.card__text {
    min-height: 250px;
}

.card__bottom {
    position: relative;
    background: none;
    padding: 6px 15px 6px 30px;
}

.card__bottom h3 {
    font-family: $font-family-sans-serif;
    font-size: 1.25rem;
    z-index: 10;
}

.card--blue .card__bottom__button {
    height: auto;
    background: none;
    padding: 0;
}

.card__bottom__button__content {
    opacity: 1;
}

.card__bottom__button__content__icon {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 30px;
}

.v-collapse-content {
    max-height: 0;
    -webkit-transition: max-height 0.3s ease-out;
    transition: max-height 0.3s ease-out;
    overflow: hidden;
    padding: 0;
}

.v-collapse-content h3 {
    pointer-events: none;
}

.v-collapse-content h3,
.v-collapse-content ul {
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    opacity: 0;
    margin-bottom: 1rem;
}

.v-collapse-content-end {
    -webkit-transition: max-height 0.3s ease-in;
    transition: max-height 0.3s ease-in;
    max-height: 500px;
    padding-top: 50px;
}

.v-collapse-content-end h3,
.v-collapse-content-end ul {
    opacity: 1;
}

.v-collapse-content-end + .card__bottom__button {
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    height: 50px;
}

.v-collapse-content-end + .card__bottom__button .card__bottom__read-more {
    -webkit-transition: opacity 0.3s;
    transition: opacity 0.3s;
    opacity: 0;
    padding-left: 30px;
}

.v-collapse-content-end
    + .card__bottom__button
    .card__bottom__button__content__icon {
    right: 15px;
    -webkit-transform: translateY(-50%) rotate(180deg);
    transform: translateY(-50%) rotate(180deg);
}
</style>
